import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Col,
} from "reactstrap";
import Select from "react-select";
import CustomerServices from "../../services/OrderingServices/CustomerServices";

const CreditModal = ({ isOpen, toggle, setCreditData, setIsCreditOpen,initialCustomer,creditData }) => {
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: 0,
      remarks: "",
      customerId: initialCustomer?.id || null,
    },
    validationSchema: Yup.object({
      amount: Yup.number()
        .typeError("Amount must be a number")

        .positive("Amount must be positive"),
      remarks: Yup.string().required("Remarks is required"),
      customerId: Yup.number()
        .min(1, "Please select a customer")
        .required("Customer is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      // Call the parent handler to add credit
      setCreditData(values);

      // Reset form after submission
      resetForm();

      // Close modal
      toggle();
    },
  });
  const [customerList, setCustomerList] = useState([]);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await CustomerServices.getCustomerList();

      setCustomerList(response);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchCustomers();
  }, []);
  const customerOptions =
    customerList?.map((type) => ({
      value: type.id,
      label: `${type.firstName} ${type?.lastName}`,
    })) || [];

  const selectedCustomers = customerOptions.find(
    (option) => option.value === formik.values.customerId
  );

  const handleCustomerChange = (selectedOption) => {
    formik.setFieldValue(
      "customerId",
      selectedOption ? selectedOption.value : null
    );
  };
  // whenever modal opens
useEffect(() => {
  if (isOpen) {
    formik.setValues({
      amount: creditData?.amount || 0,
      remarks: creditData?.remarks || "",
      customerId: initialCustomer?.id || null,
    });
  }
}, [isOpen, creditData, initialCustomer?.id]);

  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
      setIsCreditOpen(false);
    }
  }, [isOpen]);
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Credit</ModalHeader>
      <form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <Col lg={12} md={12} className="mb-3">
            <Label for="amount">Amount:</Label>
            <Input
              type="number"
              id="amount"
              name="amount"
              placeholder="Enter amount"
              value={formik.values.amount}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={
                formik.touched.amount && formik.errors.amount ? true : false
              }
            />
            {formik.touched.amount && formik.errors.amount && (
              <div className="text-danger">{formik.errors.amount}</div>
            )}
          </Col>
          <Col lg={12}>
            <Label for="customerId">
              Customer: <span className="text-danger">*</span>
            </Label>
            <div className="mb-3">
              <Select
                id="customerId"
                name="customerId"
                options={customerOptions}
                value={selectedCustomers || null}
                onChange={handleCustomerChange}
                placeholder="Select Customer"
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (baseStyles) => ({
                    ...baseStyles,
                    padding: "0.3rem",
                  }),
                }}
              />
              {formik.touched.customerId && formik.errors.customerId && (
                <div className="text-danger">{formik.errors.customerId}</div>
              )}
            </div>
          </Col>
          <Col lg={12} md={12} className="mb-2">
            <Label for="remarks">
              Remarks: <span className="text-danger">*</span>
            </Label>
            <Input
              type="textarea"
              rows={6}
              id="remarks"
              name="remarks"
              placeholder="Enter remarks"
              value={formik.values.remarks}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={
                formik.touched.remarks && formik.errors.remarks ? true : false
              }
            />
            {formik.touched.remarks && formik.errors.remarks && (
              <div className="text-danger">{formik.errors.remarks}</div>
            )}
          </Col>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => {
              formik.resetForm();
              toggle();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-success"
            disabled={!formik.isValid || formik.isSubmitting}
          >
            Add credit
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default CreditModal;
